'use strict'

class FormStateController {
  constructor($exceptionHandler) {
    'ngInject'
    Object.assign(
      this,
      { $exceptionHandler },
      {
        succeeded: false,
        failed: false,
        pending: false,
        attempted: false,
        attempts: 0,
        error: null,
      },
    )
  }

  setPending() {
    Object.assign(this, {
      succeeded: false,
      failed: false,
      pending: true,
      attempted: true,
      error: null,
    })
    this.attempts++
  }

  setSuccess() {
    Object.assign(this, {
      succeeded: true,
      failed: false,
      pending: false,
      error: null,
    })
  }

  setFailure(err) {
    Object.assign(this, {
      succeeded: false,
      failed: true,
      pending: false,
      error: err,
    })
    this.$exceptionHandler(err)
  }

  reset() {
    Object.assign(this, {
      succeeded: false,
      failed: false,
      pending: false,
      attempted: false,
      attempts: 0,
      error: null,
    })
  }
}

export const umsSubmit = ($parse, $q) => {
  'ngInject'

  return {
    restrict: 'A',
    require: ['form', 'umsSubmit'],
    controller: FormStateController,
    compile: function () {
      return {
        pre: function (scope, element, attributes, controllers) {
          const formController = controllers[0]
          formController.submission = controllers[1]
        },
        post: function (scope, element, attributes, controllers) {
          const formController = controllers[0]
          const submissionController = controllers[1]

          const fn = $parse(attributes.umsSubmit)
          formController.$submit = function () {
            formController.$setSubmitted()
            if (formController.$invalid) return
            submissionController.setPending()

            $q.when(fn(scope))
              .then(function () {
                submissionController.setSuccess()
              })
              .catch(function (err) {
                submissionController.setFailure(err)
              })
          }
        },
      }
    },
  }
}

export const input = () => {
  return {
    require: ['?ngModel', '?^form'],
    restrict: 'E',
    link: function (scope, elm, attrs, ctrl) {
      const ngModel = ctrl[0]
      const formController = ctrl[1]

      if (ngModel) {
        scope.$watch(
          () => ngModel.$touched,
          (touched) => {
            if (touched && formController) formController.$touched = true
          },
        )
      }
    },
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/ums-forms.directive.js